"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { DB_VERSION_CURRENT } from "./constants.js";
import { addKnownInstance, deleteKnownInstance } from "./knownInstances.js";
import { migrations } from "./migrations.js";
import { clearAllCaches } from "./cache.js";
import { lifecycle } from "../_utils/lifecycle.ts";
const openReqs = {};
const databaseCache = {};
function createDatabase(instanceName) {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(instanceName, DB_VERSION_CURRENT.version);
    openReqs[instanceName] = req;
    req.onerror = reject;
    req.onblocked = () => {
      console.error("idb blocked");
    };
    req.onupgradeneeded = (e) => {
      const db = req.result;
      const tx = req.transaction;
      const migrationsToDo = migrations.filter(
        ({ version }) => e.oldVersion < version
      );
      function doNextMigration() {
        if (!migrationsToDo.length) {
          return;
        }
        const { migration } = migrationsToDo.shift();
        migration(db, tx, doNextMigration);
      }
      doNextMigration();
    };
    req.onsuccess = () => resolve(req.result);
  });
}
export function getDatabase(instanceName) {
  return __async(this, null, function* () {
    if (!instanceName) {
      throw new Error("instanceName is undefined in getDatabase()");
    }
    if (!databaseCache[instanceName]) {
      databaseCache[instanceName] = yield createDatabase(instanceName);
      yield addKnownInstance(instanceName);
    }
    return databaseCache[instanceName];
  });
}
export function dbPromise(db, storeName, readOnlyOrReadWrite, cb) {
  return __async(this, null, function* () {
    return new Promise((resolve, reject) => {
      const tx = db.transaction(storeName, readOnlyOrReadWrite);
      const store = typeof storeName === "string" ? tx.objectStore(storeName) : storeName.map((name) => tx.objectStore(name));
      let res;
      cb(store, (result) => {
        res = result;
      });
      tx.oncomplete = () => resolve(res);
      tx.onerror = () => reject(tx.error);
    });
  });
}
export function deleteDatabase(instanceName) {
  return new Promise((resolve, reject) => {
    const openReq = openReqs[instanceName];
    if (openReq && openReq.result) {
      openReq.result.close();
    }
    delete openReqs[instanceName];
    delete databaseCache[instanceName];
    const req = indexedDB.deleteDatabase(instanceName);
    req.onsuccess = () => resolve();
    req.onerror = () => reject(req.error);
    req.onblocked = () => console.error(`database ${instanceName} blocked`);
  }).then(() => deleteKnownInstance(instanceName)).then(() => clearAllCaches(instanceName));
}
export function closeDatabase(instanceName) {
  const openReq = openReqs[instanceName];
  if (openReq && openReq.result) {
    openReq.result.close();
  }
  delete openReqs[instanceName];
  delete databaseCache[instanceName];
  clearAllCaches(instanceName);
}
if (ENAFORE_IS_BROWSER) {
  lifecycle.addEventListener("statechange", (event) => {
    if (event.newState === "frozen") {
      Object.keys(openReqs).forEach((instanceName) => {
        closeDatabase(instanceName);
        console.log("closed instance DBs");
      });
    }
  });
}
